/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Translate_ErrorInputs */

const sv_google_translate_error = /** @type {(inputs: Google_Translate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Översättning är inte tillgänglig. Öppna språkmenyn för att försöka igen.`)
};

const en_google_translate_error = /** @type {(inputs: Google_Translate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation is unavailable. Open the language menu to try again.`)
};

/**
* | output |
* | --- |
* | "Translation is unavailable. Open the language menu to try again." |
*
* @param {Google_Translate_ErrorInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const google_translate_error = /** @type {((inputs?: Google_Translate_ErrorInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Translate_ErrorInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_google_translate_error(inputs)
	return en_google_translate_error(inputs)
});